module.exports = __webpack_public_path__ + "static/media/list.fe12d169.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/list.svg
// module id = 542
// module chunks = 0